/** Do not edit this file, it is automatically generated **/
import React, { PropsWithChildren } from "react";
import styled from "styled-components";

import Icon, { IconProps } from "./Icon";

const IconAcceptLineComponent: React.FC<PropsWithChildren<IconProps>> & { DataUrl: string; Content: string; } = (props) => {
return (
  <Icon {...props} viewBox="0 0 512 512">
    <path d="m501.09 134.047-296.684 296.682a37.352 37.352 0 0 1 -52.764 0l-140.733-140.729a37.31 37.31 0 0 1 52.764-52.764l106.68 106.683a10.849 10.849 0 0 0 15.342 0l262.631-262.636a37.31 37.31 0 0 1 52.764 52.764z">
</path>
  </Icon>
);
};

IconAcceptLineComponent.DataUrl = "data:image/svg+xml;charset=utf-8;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNTEyIDUxMiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aCBkPSJtNTAxLjA5IDEzNC4wNDctMjk2LjY4NCAyOTYuNjgyYTM3LjM1MiAzNy4zNTIgMCAwIDEgLTUyLjc2NCAwbC0xNDAuNzMzLTE0MC43MjlhMzcuMzEgMzcuMzEgMCAwIDEgNTIuNzY0LTUyLjc2NGwxMDYuNjggMTA2LjY4M2ExMC44NDkgMTAuODQ5IDAgMCAwIDE1LjM0MiAwbDI2Mi42MzEtMjYyLjYzNmEzNy4zMSAzNy4zMSAwIDAgMSA1Mi43NjQgNTIuNzY0eiI+CiAgPC9wYXRoPgo8L3N2Zz4=";
IconAcceptLineComponent.Content = `<svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
  <path d="m501.09 134.047-296.684 296.682a37.352 37.352 0 0 1 -52.764 0l-140.733-140.729a37.31 37.31 0 0 1 52.764-52.764l106.68 106.683a10.849 10.849 0 0 0 15.342 0l262.631-262.636a37.31 37.31 0 0 1 52.764 52.764z">
  </path>
</svg>`;

const IconAcceptLine = styled(IconAcceptLineComponent)``;

export default IconAcceptLine;
